<script>
  import Comments from './Comments.svelte';
  import DropDown from '../../components/DropDown.svelte';
  import Select from 'svelte-select';
  import { client } from 'root/api/index.js';
  import { createForm } from 'svelte-forms-lib';
  import * as yup from 'yup';
  import { onDestroy, onMount, getContext } from 'svelte';
  import { masterData, getMasterData } from '../../stores/masterData.js';
  import { authStore, getUserInfo } from '../../stores/auth';
  import Loader from '../../components/Loader.svelte';
  import InfiniteScroll from '../../components/DataTable/InfiniteScroll.svelte';
  import {
    configItem,
    customInputEvent,
    searchKeyByValue,
    dbDateFormat,
    getValueBySearchValue,
  } from '../../components/Helper.js';
  import FormTextarea from '../../components/FormControls/FormTextarea.svelte';
  import DatePicker from '../Flatpickr/DatePicker.svelte';

  const showDialog = getContext('showDialog');

  let id = 0;
  let cateogry = [];
  let isFormPending = false;
  let serverErrors = [];
  let hasMore = false;
  let pageSize = 30;
  let pageNumber = 1;
  let notesData = [];
  let isPaginationLoading = false;
  let totalComments = '';
  let datePickerRef = '';
  export const show = (clientId) => {
    id = clientId;
    pageNumber = 1;
    hasMore = false;
    notesData = [];
    $form = { ...defaultValue };
    $form.clientId = id;
    $errors = {};
    extraFilter.clientId = id;
  };
  let userList = [];
  const getNotesList = () => {
    if (id == 0) {
      return;
    }
    isPaginationLoading = true;
    let firstId = notesData.length > 0 ? notesData[0].id : '';
    client
      .clientNotesList(pageSize, pageNumber, { ...extraFilter, firstId })
      .then((response) => {
        if (cateogry.length == 0) {
          cateogry = response.data.noteCategory;
        }
        isPaginationLoading = false;
        if (response.data.pagination.pageNumber == 1) {
          notesData = response.data.payload;
        } else {
          notesData = response.data.payload.concat(notesData);
        }
        totalComments = response.data.pagination.totalCount;
        hasMore = response.data.hasMore;
      })
      .catch((err) => {
        showDialog({ message: err.message });
      });
    getClientNotesUserList();
  };
  const getClientNotesUserList = () => {
    if (id == 0) {
      return;
    }
    isPaginationLoading = true;
    let firstId = notesData.length > 0 ? notesData[0].id : '';
    let oldUserList = userList;
    client
      .clientNotesUserList({ ...extraFilter, firstId })
      .then((response) => {
        let userListData = response.data;
        userList = userListData;
      })
      .catch((err) => {
        showDialog({ message: err.message });
      });
  };

  let defaultFilter = {
    searchKeyword: '',
    fromDate: '',
    toDate: '',
    clientId: '',
    users: [],
    notesCategories: '',
  };
  let defaultValue = {
    id: '',
    notesCategories: undefined,
    notes: '',
    tags: [],
    clientId: '',
  };
  let tagify;
  const { form, errors, handleChange, handleSubmit } = createForm({
    initialValues: { ...defaultValue },
    validationSchema: yup.object().shape({
      notes: yup.string().required('Comment is required'),
      clientId: yup.string().required('Client is required'),
      notesCategories: yup
        .array()
        .required('Select category')
        .min(1, 'Select category')
        .of(
          yup.object().shape({
            id: yup.string(),
            name: yup.string(),
          }),
        ),
    }),
    onSubmit: (values) => {
      isFormPending = true;
      client
        .clientNoteSave(values)
        .then((response) => {
          isFormPending = false;
          $form = { ...defaultValue };
          $form.clientId = id;
          filterData();
          tagify.setContents('');
          // tagify.destroy()
          // setTimeout(()=>{
          //   bindTagify();
          // },10)
        })
        .catch((err) => {
          isFormPending = false;
          serverErrors = [err.message];
          showDialog({ message: serverErrors });
        });
    },
  });

  let extraFilter = { ...defaultFilter };
  const filterData = () => {
    pageNumber = 1;
    hasMore = false;
    notesData = [];
    getNotesList();
  };
  $: extraFilter && filterData();

  function onItemSelect(event) {
    extraFilter.notesCategories = event.detail;
  }
  let userRoleId = getUserInfo().roleId;

  // import Tagify from '@yaireo/tagify'
  // import "@yaireo/tagify/dist/tagify.css" // Tagify CSS

  import 'quill-mention';
  import { insert } from 'svelte/internal';
  const bindTagify = async () => {
    let toolbarOptions = [
      [
        { header: 1 },
        { header: 2 },
        'blockquote',
        'bold',
        'italic',
        'underline',
        'strike',
        { list: 'bullet' },
        { list: 'ordered' },
      ],
    ];
    const { default: Quill } = await import('quill');
    tagify = new Quill(tagifyRef, {
      modules: {
        toolbar: toolbarOptions,
        /*mention: {
		  allowedChars: /^[A-Za-z\sÅÄÖåäö]*$/,
		  mentionDenotationChars: ["@"],
		  source: async function(searchTerm, renderList) {
			if(searchTerm.trim()!=""){
			  client.taskSearch({searchKeyword:searchTerm,clientId:id}).then((response) => {
				let whitelist=response.data.map(item=>{
				  item.value=item.name;
				  return item
				});
				renderList(whitelist)
			  });
			}
		  }
		}*/
      },
      theme: 'snow',
      placeholder: 'Enter your comments here...',
    });
    tagify.on('text-change', function (delta, oldDelta, source) {
      $form.notes =
        tagify.getText().trim() != '' || tagify.getContents().length > 1
          ? tagify.container.firstChild.innerHTML
          : '';
    });
    tagify.on('blur', function (delta, oldDelta, source) {
      handleChange(customInputEvent(`notes`, $form.notes));
      $errors.notes = undefined;
    });
  };
  // const bindTagify=()=>{
  //   var controller;
  //   tagify = new Tagify(tagifyRef,{
  //       mode: 'mix',
  //       pattern: /@/,
  //       tagTextProp: 'text',
  //       enforceWhitelist: true,
  //       whitelist:[]
  //   })
  //   .on('input', (e )=>{
  //       tagify.settings.whitelist.length = 0;
  //       controller && controller.abort();
  //       controller = new AbortController();
  //       tagify.loading(true).dropdown.hide.call(tagify)
  //       var detail = e.detail;
  //       if(detail.prefix!=undefined && detail.value.trim()!=""){
  //         let value=detail.value.trim();
  //          client.taskSearch({searchKeyword:value,clientId:id}).then((response) => {
  //           let whitelist=response.data.map(item=>{
  //             item.value=item.name;
  //             return item
  //           });
  //           tagify.settings.whitelist=whitelist;
  //           tagify.loading(false).dropdown.show.call(tagify, value);
  //         });
  //       }
  //       $form.tags=tagify.value
  //       $form.notes=tagifyRef.value
  //       handleChange(customInputEvent(`notes`, $form.notes));
  //   })
  // }
  let tagifyRef;
  onMount(() => {
    bindTagify();
  });
  let categorySave = false;

  const clientNoteCategorySave = (detail, newItem) => {
    // categorySave=true
    client.clientNoteCategorySave({ name: detail[newItem].name }).then((response) => {
      detail[newItem].id = response.data.id;
      cateogry = [...cateogry, detail[newItem]];
      handleChange(customInputEvent(`notesCategories`, detail));
    });
  };

  function showDelete(selectId) {
    showDialog({
      isDeleteModel: true,
      type: 'confirm',
      title: '',
      message: 'Are you sure?',
      okFunc: () => {
        client
          .clientNoteDelete({ id: selectId, clientId: id })
          .then((response) => {
            filterData();
          })
          .catch((err) => {
            showDialog({ message: err.message });
          });
      },
    });
  }
  function showEdit(selectId) {
    client
      .clientNoteGet({ id: selectId, clientId: id })
      .then((response) => {
        $form = {
          clientId: response.data.notes.client_id,
          id: response.data.notes.id,
          notes: response.data.notes.notes,
          notesCategories: response.data.notesCategories,
        };
        tagify.container.firstChild.innerHTML = response.data.notes.input_notes;
      })
      .catch((err) => {
        showDialog({ message: err.message });
      });
  }
</script>

<div class="d-flex flex-column h-100 content-section">
  <div class="p-3 pb-0">
    <div class="d-flex flex-row justify-content-between">
      <div class="position-relative search-comments w-100">
        <input
          placeholder="Search any comment..."
          class="mb-0 form-control"
          type="search"
          bind:value={extraFilter.searchKeyword}
        />
      </div>
      <div class="d-flex flex-row justify-content-between ms-2 w-100">
        <div
          class="date-picker date-range-picker w-100"
          style="position: relative;"
        >
          <DatePicker
            mode="range"
            showMonths="2"
            bind:this={datePickerRef}
            placeholder="Select Date(s)"
            on:close={(value) => {
              let event = value.detail[0];
              if (event.length == 1) {
                event = [];
                extraFilter.fromDate = event[0] != undefined ? dbDateFormat(event[0]) : '';
                extraFilter.toDate = event[1] != undefined ? dbDateFormat(event[1]) : '';
              }
            }}
            on:change={(value) => {
              let event = value.detail[0];
              if (event.length == 1) {
                return false;
              }
              extraFilter.fromDate = event[0] != undefined ? dbDateFormat(event[0]) : '';
              extraFilter.toDate = event[1] != undefined ? dbDateFormat(event[1]) : '';
            }}
          />
          {#if extraFilter.fromDate != '' || extraFilter.toDate != ''}
            <button
              class="remove-btn bg-transparent border-0"
              on:click={() => {
                datePickerRef.clear();
              }}
            >
              <img
                alt=""
                src="/images/close.svg"
              />
            </button>
          {/if}
        </div>
      </div>
      <div class="customer-group-picker ms-2 me-1 d-flex flex-row align-items-center">
        <div class="customer-picker">
          <DropDown
            checkbox={true}
            searchbox={true}
            active={false}
            removeIcon={true}
            title="User"
            option={userList}
            Style="select-block client-filter-dropdown"
            checkedFields="checked"
            on:onSelect={(event) => {
              extraFilter.users = event.detail;
            }}
            on:onClear={(event) => {
              extraFilter.users = [];
            }}
          />
        </div>
      </div>
      <div class="d-flex flex-row align-items-center">
        <DropDown
          checkbox={true}
          removeIcon={true}
          searchbox={true}
          active={true}
          title="Select: Categories"
          option={cateogry}
          Style="select-block ms-1"
          dropDownStyle={' dropdown-menu-end right-position'}
          on:onSelect={onItemSelect}
          on:onClear={(event) => {
            extraFilter.notesCategories = [];
          }}
        />
      </div>
    </div>
    {#if notesData.length > 0}
      <div class="d-flex align-items-center mb-1 text-center justify-content-center">
        <span class="text-muted mt-2 d-block total-comments">{totalComments} Comments</span>
      </div>
    {/if}
  </div>

  <div class="page-content p-3">
    {#if notesData.length <= 0 && !isPaginationLoading}
      <div class=" d-flex align-items-center justify-content-center h-100 w-100 flex-column">
        <svg
          width="55"
          height="55"
          viewBox="0 0 100 100"
          fill="#C8D6E7"
          xmlns="http://www.w3.org/2000/svg"
          ><path
            d="M91 14V70.8285H38.2686L19.25 90V70.8285H9V14H91ZM85.875 19.1662H14.125V65.6622H24.375V77.488L36.1064 65.6622H85.875V19.1662ZM60.25 44.9973H55.125V34.6649H65.375V44.9973C65.375 45.7238 65.2415 46.3965 64.9746 47.0154C64.7077 47.6343 64.3473 48.1724 63.8936 48.6298C63.4398 49.0873 62.8926 49.464 62.252 49.76C61.6113 50.0559 60.944 50.1905 60.25 50.1636V44.9973ZM39.75 44.9973H34.625V34.6649H44.875V44.9973C44.875 45.7238 44.7415 46.3965 44.4746 47.0154C44.2077 47.6343 43.8473 48.1724 43.3936 48.6298C42.9398 49.0873 42.3926 49.464 41.752 49.76C41.1113 50.0559 40.444 50.1905 39.75 50.1636V44.9973Z"
            fill=""
          /></svg
        >
        <span class="color-lead font-size-18 mt-2 d-block">No notes yet</span>
      </div>
    {/if}
    {#each notesData as itemData, itemkey}
      <Comments
        itemData={itemData}
        showDelete={showDelete}
        showEdit={showEdit}
      />
    {/each}
    <InfiniteScroll
      threshold={300}
      isLoading={isPaginationLoading}
      reverse={true}
      key={notesData.length}
      hasMore={hasMore}
      on:loadMore={() => {
        pageNumber = pageNumber + 1;
        getNotesList();
      }}
    >
      <div
        class="scroll-spinner-container d-flex justify-content-center
			  align-items-center"
      >
        <Loader Style="loader-block" />
      </div>
    </InfiniteScroll>
  </div>
  <div class="p-3 post-comment">
    <div class="d-flex flex-row">
      <div class="w-100">
        <div class="mb-3 position-relative client-comments-textarea {$errors.notes ? 'error' : ''}">
          <div bind:this={tagifyRef}>
            <slot></slot>
          </div>
          <!-- <textarea bind:this={tagifyRef} name="notes" class="w-100 form-control  comments-tag-input" bind:value={$form.notes} placeholder="Enter your comments here..." on:change={handleChange}></textarea>             -->
          {#if $errors.notes}
            <label
              class="formError"
              for="notes">{$errors.notes}</label
            >
          {/if}

          <button
            class="send send-comments position-absolute color-blue font-weight-600 border-0 mb-0 rounded-circle background-blue"
            on:click={() => handleSubmit()}
          >
            {#if isFormPending}
              <Loader />
            {:else}
              <img
                alt=""
                src="/images/send.svg"
              />
            {/if}
          </button>
          {#if $form.id > 0}
            <button
              class="position-absolute close-tagy-btn"
              title="Undo Editing"
              on:click={() => {
                $form = { ...defaultValue };
                $form.clientId = id;
                tagify.setContents('');
              }}
            >
              <img
                alt=""
                src="/images/cross-white.svg"
              />
            </button>
          {/if}
        </div>
        <!-- <FormTextarea bind:this={tagifyRef} name="notes" placeholder="Enter your comments here..." {handleChange} error={$errors.notes} bind:value={$form.notes} /> -->
        <div
          style="height:50px;"
          class="w-100 position-relative {$errors.notesCategories && $errors.notesCategories != ''
            ? 'error'
            : ''}"
        >
          {#if categorySave}
            <Loader />
          {:else}
            <Select
              bind:selectedValue={$form.notesCategories}
              placeholder="Select: Categories"
              isMulti={true}
              containerClasses="form-control"
              items={cateogry}
              createItem={(filterText) => {
                return {
                  name: filterText,
                  id: -1,
                };
              }}
              getSelectionLabel={(option, filterText) => {
                return option.name;
              }}
              on:select={(ev) => {
                if (ev.detail !== null) {
                  let detail = ev.detail;
                  let newItem = searchKeyByValue(detail, 'id', -1);
                  if (newItem != -1) {
                    let oldItem = searchKeyByValue(cateogry, 'name', detail[newItem].name);
                    if (oldItem != -1) {
                      detail[newItem].id = cateogry[oldItem].id;
                      handleChange(customInputEvent(`notesCategories`, detail));
                    } else {
                      clientNoteCategorySave(detail, newItem);
                    }
                  } else {
                    handleChange(customInputEvent(`notesCategories`, detail));
                  }
                }
              }}
              on:clear={(ev) => {}}
              optionIdentifier="id"
              isCreatable={userRoleId == configItem.roleIndex.admin}
              getOptionLabel={(option, filterText) => {
                return option.isCreator ? `Create \"${filterText}\"` : option.name;
              }}
            />
            {#if $errors.notesCategories != undefined}
              <label class="formError">{$errors.notesCategories}</label>
            {/if}
          {/if}
        </div>
      </div>
    </div>
  </div>
</div>

<style lang="scss">
  :global(.ql-editor) {
    max-height: 250px !important;
    min-height: 80px !important;
    height: auto !important;
  }
  :global(.text-editor.dark-mode) {
    background-color: var(--clr-base);
    border: 1px solid var(--input-border);
  }
  :global(.dark-mode .ql-toolbar.ql-snow),
  :global(.dark-mode .ql-container.ql-snow) {
    border: 1px solid var(--input-border);
  }
  :global(.dark-mode .ql-editor) {
    color: var(--light);
  }

  :global(
    .dark-mode .ql-snow .ql-picker.ql-header .ql-picker-label::before,
    .ql-snow .ql-picker.ql-header .ql-picker-item::before
  ) {
    color: var(--clr-base-lt) !important;
  }
  :global(.dark-mode .ql-snow .ql-stroke) {
    stroke: var(--clr-base-lt) !important;
  }

  :global(.ql-editor.ql-blank::before) {
    color: var(--clr-base-lt);
  }
  :global(.ql-editor a) {
    color: var(--clr-secondary);
  }

  .search-comments {
    input {
      width: 100%;
      padding-right: 28px;
    }
  }
  .post-comment {
    background: rgba($input-border-color, 0.3);
    .send-btn {
      flex: 0 0 50px;
      max-width: 50px;
      textarea {
        resize: none;
      }
      button {
        width: 40px;
        height: 40px;
        background-color: #206bc4;
        margin-top: 16px;
        img {
          width: 20px;
          height: 20px;
        }
      }
    }
  }
  .total-comments {
    background: rgba(205, 217, 233, 0.3);
    display: inline-block !important;
    font-size: 12px !important;
    padding: 3px 10px;
    border-radius: 20px;
    border: 1px solid rgba(205, 217, 233, 0.6);
  }
  .send-comments {
    width: 56px;
    position: absolute !important;
    right: 12px;
    top: 54px;
    width: 40px;
    height: 40px;
    img {
      width: 20px;
      height: 20px;
    }
  }
  .remove-btn {
    /*display: none;*/
    position: absolute;
    right: -3px;
    top: -4px;
    width: 17px;
    background: $lead-color !important;
    width: 16px;
    height: 16px !important;
    border-radius: 6px !important;
    line-height: 0px;
    padding: 0px;
    z-index: 1;

    img {
      width: 8px;
    }
    &:hover {
      background: $black-color !important;
    }
  }
  :global(.client-comments-textarea .ql-editor) {
    padding-right: 60px !important;
  }
</style>
